import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import ReservationPage from './components/ReservationPage';
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket';
import ScrollToTop from './providers/ScrollToTop';
import {PromoProvider} from "./providers/Init"

function App() {
  return (
     <PromoProvider> 
    <div className="App">
      <ScrollToTop />
      <WebSocket />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/reservation" element={<ReservationPage />} />
        {ThreeDSRoutes()}
      </Routes>
    </div>
       </PromoProvider>
  );
}

export default App;
